export const INITIAL_DATA = {
    name: "",
    beschreibung: "",
    zielmuskel: "",
    kategorie: "",
};

export const ZIELMUSKEL_OPTIONS = [
    { value: "Brust", label: "Brust" },
    { value: "Ruecken", label: "Rücken" },
    { value: "Schultern", label: "Schultern" },
    { value: "Bizeps", label: "Bizeps" },
    { value: "Trizeps", label: "Trizeps" },
    { value: "Beine", label: "Beine" },
    { value: "Bauch", label: "Bauch" },
];

export const KATEGORIE_OPTIONS = [
    { value: "Push", label: "Push" },
    { value: "Pull", label: "Pull" },
    { value: "Beine", label: "Beine" },
];

export const ZIELMUSKEL_LABELS = Object.fromEntries(
    ZIELMUSKEL_OPTIONS.map(({ value, label }) => [value, label])
);
